import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/home/Home";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Blog from "../pages/blog/Blog";
import BlogDetails from "../pages/blog/BlogDetails";
import Contact from "../pages/Contact";
import Category from "../pages/category/Category";
import Collaboration from "../pages/collaboration/Collaboration";
import Faqs from "../pages/Faqs";
import OurStory from "../pages/OurStory";
import Privacy from "../pages/privacy/Privacy";




export default function Router() {
    const [headerData, setHeaderData] = useState(null);

    return (
        <>


            <Header setHeaderData={setHeaderData} />
            <Routes>
                <Route path="/" element={<Home headerData={headerData} />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:name" element={<BlogDetails />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/category" element={<Category />} />
                <Route path="/category/:name" element={<Category />} />
                <Route path="/collaboration" element={<Collaboration />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="/our-story" element={<OurStory />} />
                <Route path="/privacy" element={<Privacy />} />

            </Routes>
            <Footer />

        </>
    );
}